import { StaticBaseDao } from '@/dao';
import { ChronoTrack } from '@/objects/generated';

export class ChronoTrackDao extends StaticBaseDao {
    public static async GetChronoTracks(): Promise<ChronoTrack[]> {
        return this.BaseFetchArray(ChronoTrack, `ChronoTrack/Fetch`, 'GET');
    }
}
